document.querySelectorAll('.nav-ul .nav-li > .nav-link').forEach(link => {
  link.addEventListener('click', (e) => {
    e.stopPropagation();
    const parentLi = link.parentElement;
    
    if (parentLi.classList.contains('nav-li-open')) {
      parentLi.classList.remove('nav-li-open');
    } else {
        
      const siblings = Array.from(parentLi.parentElement.children).filter(li => li !== parentLi);
      siblings.forEach(sib => sib.classList.remove('nav-li-open'));
      
      parentLi.classList.add('nav-li-open');
    }
  });
});

// document.addEventListener('click', () => {
//   document.querySelectorAll('.nav-li-open').forEach(li => li.classList.remove('nav-li-open'));
// });



document.addEventListener("DOMContentLoaded", function () {
  const langCurrency = document.querySelector(".lang-currency");

  if (langCurrency) {
    langCurrency.addEventListener("mouseenter", function () {
      langCurrency.classList.add("open");
    });

    langCurrency.addEventListener("mouseleave", function () {
      langCurrency.classList.remove("open");
    });
  }
});
